"use strict";

(function (global) {

  global.dropping = {
    droppable: ".Fol_obj, .List.EDoc_obj, .List.Job_obj, .List.Task_obj",
    jDroppbable: null,

    /**
    * Проверка возможности вставки ссылок указанного типа в папку с
    * указанным типом.
    * @function Core.dropping.isfolderAcceptObject
    * @since 5.1.0.1523
    * @return {boolean}
    */
    isfolderAcceptObject: function (folderType, objectType) {
      if (!folderType) return false;
      //Приведенные ниже числа -это значения глбального перечисления OBJECT_TYPE
      var associations = {
        '1': [0, 1],
        '2': [0, 2],
        '3': [0, 3],
        '5': [0, 1, 2, 3, 5, 9]
      }
      return associations[folderType].indexOf(objectType) !== -1
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Обработка нажатия клавиши CTRL
     *
     * @method Core.dropping.enableCopyButton
     * @since 5.1.0.1523
     */
    enableCopyButton(event) {
      const jObjectListItem = $('.object-list-item.ui-draggable');
      if (event.ctrlKey) {
        Core.dropping.isCopyKeyPressed = true;
        jObjectListItem.addClass('cursorCopy');
      } else {
        Core.dropping.isCopyKeyPressed = false;
        Core.dropping.onDropEnd(jObjectListItem);
      }
    },

    /**
     * Обработка окончания перетаскивания элементов.
     *
     * @method Core.dropping.onDropEnd
     * @param {object} [jItems] Список jQuery-элементов перетаскивания.
     * @since 5.7.0.9000
     */
    onDropEnd(jItems = $('.object-list-item.ui-draggable')) {
      jItems.removeClass('cursorCopy');
    },

    /**
    * Получение id элемента в дереве
    * @method Core.dropping.getTreeItemId
    * @return {Integer} id
    * @since 5.1.0.1523
    */
    getTreeItemId: function (jObject) {
      return jObject.find('a').attr('id').replace('f','');
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Получение id родителя элемента в дереве
    * @method Core.dropping.getTreeItemParentId
    * @return {Integer} id
    * @since 5.1.0.1523
    */
    getTreeItemParentId: function (id) {
      if (WA.FC.folders.isRootFolder(id)) return id;
      return $("#f" + id).parents('ul').first().parents('.collapsable').first().find('.Fol_obj:first').find('a').attr('id').replace('f', '');
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Получение ссылок перемещаемых объектов
    * @function Core.dropping.getDraggingLinks
    * @since 5.1.0.1523
    * @return {WA.Link[]} список ссылок
    */
    getDraggingLinks: function (jDraged) {
      var me = this;
      var links = [];
      if (jDraged.is('span')) {
        //Папка из дерева папок
        links = [new WA.Link(me.getTreeItemId(jDraged), OBJECT_TYPE.FOLDER)];
      } else {
        //Объект из списка объектов

        links = WA.CR.objectList.getSelectedItems();
      }
      return links;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Настройка элементов, В(!) которые можно перетаскивать
    * @function Core.dropping.dropSetup
    * @since 5.1.0.1523
    * @return {Core.dropping}
    */
    init: function () {
      var me = this;
      log.info('DRAG&DROP', 'Init dropable');

      me.jDroppbable = $(me.droppable).not('drop_binded');

      var settings = {
        accept(jDraged) {
          const jReciever = $(this);

          // Необходимо вернуть вид курсора к нормальному
          Core.dropping.onDropEnd();

          //Игнорируем все элементы кроме объектов из спика и дерева папок
          if (!jDraged.is('div.List') && !jDraged.is('span.Fol_obj')) {
            return;
          }

          const links = me.getDraggingLinks(jDraged);
          const recieverType = me.getObjectType(jReciever);

          switch (recieverType) {
            case OBJECT_TYPE.FOLDER:
              /**
               * Разрешаем вставлять в соответствующие папки
               */
              const folderType = me.getFolderType($(this));
              return links.some(link => me.isfolderAcceptObject(folderType, link.type));
            case OBJECT_TYPE.EDOCUMENT:
              /**
               * Разрешаем связывать документы c документами
               */
              return links.some(link => link.type === OBJECT_TYPE.EDOCUMENT);
            default:
              /**
               * В task-и и job-ы можно вкладывать все
               */
              return [OBJECT_TYPE.JOB, OBJECT_TYPE.TASK].includes(recieverType);
          }
        },
        hoverClass: "dragAllowed",
        tolerance: "pointer",
        drop(event, ui) {
          const links = me.getDraggingLinks($(ui.draggable));
          const dragIsFromFolderTree = $(ui.draggable).is('span');
          me.handleDrop(links, $(this), dragIsFromFolderTree);
          return true;
        }
      };
      me.jDroppbable.droppable(settings).addClass('drop_binded');
      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//


    /**
    * Отменяем текущую операцию по нажатию клавиши ESC
    * @function Core.dropping.enableEscapeButton
    * @since 5.1.0.1523
    * @return {Core.dropping}
    */
    enableEscapeButton: function () {
      var me = this;
      $(document).keyup(function (e) {
        if (e.which === 27 || e.keyCode === 27) {
          me.isCancelKeyPressed = true;
          $('.ui-draggable-dragging').draggable({ 'revert': true }).trigger('mouseup');
          setTimeout(function () {
            me.isCancelKeyPressed = false;
          }, 100);
        }
      });
      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Отсеивание элементов, которые не подходят под разрешенное содержимое
    * папок.
    * @function Core.dropping.filterLinks
    * @since 5.1.0.1523
    * @return {Core.dropping}
    */
    filterLinks: function (links, destID, destType, jReciever) {
      var me = this;
      var filtered = [];
      if (destType === OBJECT_TYPE.FOLDER) {
        var folderType = me.getFolderType(jReciever);
        for (var i = 0; i < links.length; i++) {
          if (me.isfolderAcceptObject(folderType, links[i].type) && destID != links[i].id) {
            filtered.push(links[i]);
          }
        };
      };

      if (destType === OBJECT_TYPE.EDOCUMENT) {
        for (var i = 0; i < links.length; i++) {
          if (links[i].type === OBJECT_TYPE.EDOCUMENT) filtered.push(links[i]);
        };
      };

      if (destType === OBJECT_TYPE.TASK || destType === OBJECT_TYPE.JOB) {
        filtered = links;
      };

      return filtered;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Чтобы отобразить в модальном диалоге имя объекта в который будет
    * произведена вставка
    * необходио знать его имя. Получаем имя из существующих DOM-элементов;
    * @function Core.dropping.getObjectName
    * @since 5.1.0.1523
    * @param {Object} jObject - объект списка
    * @return {String}
    */
    getObjectName: function (jObject) {
      if (jObject.is('span')) { //в дереве
        return jObject.find('a').attr('name').toString().escapeHtml();
      } else { //в списке объектов
        return (''+jObject.find('div.objectname').data('title')).escapeHtml();
      };
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Мы сами добаили выделение для объекта который переносим, сами-же его и уберем
    * @function Core.dropping.removeSelection
    * @return {Core.dropping}
    */
    removeSelection: function () {
      var links = WA.CR.objectList.getSelectedItems();
      for (var i = 0; i<links.length; i++) {
          WA.CR.objectList.selectItem(links[i]);
          setTimeout(function () {
            UpdateSelectionNumbers();
          }, 100);
       };

      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Обработка завершения перетаскивания элементов
    * @function Core.dropping.handleDrop
    * @since 5.1.0.1523
    * @return {Core.dropping}
    * @see #91791
    */
    handleDrop: function (links, jReciever, dragIsFromFolderTree) {
      var me = this;
      var destID;
      var destType;
      var filtered;
      let unselectedLinks = [];

      if (me.isCancelKeyPressed) return;

      if (jReciever.is('div')) destID = jReciever.attr('id');
      else destID = me.getTreeItemId(jReciever);

      destType = me.getObjectType(jReciever);

      if (WA.CR.objectList.isAllItemsSelected()) {
        filtered = [new WA.Link(WA.CR.getID(), OBJECT_TYPE.ANY)];       
      } else {
        filtered = me.filterLinks(links, destID, destType, jReciever);
      }      
      var actions = {};
      actions[OBJECT_TYPE.FOLDER] = {
        'question': L('CONFIRM_MOVE_TO_FOLDER', me.getObjectName(jReciever)),
        'action': function () {
          me.moveLinks(filtered, destID, destType, jReciever, dragIsFromFolderTree, unselectedLinks);
        }
      };

      actions[OBJECT_TYPE.EDOCUMENT] = {
        'question': L('CONFIRM_BIND_WITH_DOCUMENT', me.getObjectName(jReciever)),
        'action': function () {
          me.bindLinks(filtered, destID, destType, jReciever);
        }
      };

      actions[OBJECT_TYPE.TASK] = {
        'question': L('CONFIRM_ATTACH_TO_TASK', me.getObjectName(jReciever)),
        'action': function () {
          me.attachToTask(filtered, destID, destType, jReciever);
        }
      };

      actions[OBJECT_TYPE.JOB] = actions[OBJECT_TYPE.TASK];
      actions[OBJECT_TYPE.JOB].title = L('CONFIRM_ATTACH_TO_JOB', me.getObjectName(jReciever));

      //При копирвании, не спрашиваем ничего
      if (me.isCopyKeyPressed) {
        actions[OBJECT_TYPE.FOLDER].action();
        return me;
      }

      // Переносим без подтверждения (tfs bug #6024)
      actions[destType].action();

      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Перемещение ссылок
    * @param {WA.Link[]} links список ссылок
    * @param {Integer} destID if элемента получателя
    * @param {OBJECT_TYPE} destType элемента получателя
    * @param {OBJECT_TYPE} jReciever jquery объект получателя
    * @param {WA.Link[]} unselectedLinks список невыбранных ссылок
    * @function Core.dropping.handleDrop
    * @since 5.1.0.1523
    * @return {Core.dropping}
    */
    moveLinks: function (links, destID, destType, jReciever, dragIsFromFolderTree, unselectedLinks) {
      var me = this;

      var sourceID;
      var sourceType;

      var OL = WA.CR.objectList;
      var toast = new WA.CMP.NTF.Toast();

      if (links.length === 0) {
        toast.show(L('NOT_LINKS_TO_MOVE'));
        return me;
      }

      if (dragIsFromFolderTree) {
        // Если перемещение происходит из дерева, то объект всегда один
        // и это папка. Источником является родительская папка.
        sourceID = me.getTreeItemParentId(links[0].id);
        sourceType = OBJECT_TYPE.FOLDER;
      } else {
        // Если это список объектов, то источником является текущая
        // открытая сущьность.
        sourceID = WA.CR.getID();
        sourceType = WA.CR.getObjectType();
      };

      //Для того, чтобы не перемещать из избранного в избранное удаляя потом объекты
      if (!dragIsFromFolderTree && WA.CR.getID() == destID) {
        toast.show(L('NOT_LINKS_TO_PASTE'));
        return me;
      };

      function refreshAll() {
        WA.CR.folderTree.update();

        me.removeSelection();
        UpdateSelectionNumbers();
      };

      var pastedCount; //#91724
      WA.SRV.session.pasteLinks(links, destID, destType).done(function (count) {
        pastedCount = count;
        if (me.isCopyKeyPressed || (new WA.URL()).getParam('mode') === 'search') {
          if (count > 0) {
            toast.show(L('COPIED_LINKS', count));
          } else {
            toast.show(L('NOT_LINKS_TO_COPY'));
          }
          refreshAll();
        } else {
          if (links.length > 0 && count == 0) {
            toast.show(L('NOT_LINKS_TO_MOVE'));
            refreshAll();
            return;
          }
          WA.SRV.session.deleteLinks(links, sourceID, sourceType, unselectedLinks).done(function (count) {
            if (count > 0) {
              OL.removeItems(links, true);
              OL.fire("itemsChange");
              OL.fire('onSelect', null, OL.getSelectedItems());
              toast.show(L('MOVED_LINKS', count));
            } else {
              if (pastedCount > 0) {
                toast.show(L('COPIED_LINKS', pastedCount));
              } else {
                toast.show(L('NOT_LINKS_TO_MOVE'));
              }
            }
            refreshAll();
          });
        };
      });
      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Связывание документов
    * @function Core.dropping.bindLinks
    * @param {WA.Link[]} links список ссылок
    * @param {Integer} destID if элемента получателя
    * @param {OBJECT_TYPE} destType элемента получателя
    * @param {OBJECT_TYPE} jReciever jquery объект получателя
    * @since 5.1.0.1523
    * @return {Core.dropping}
    */
    bindLinks: function (links, destID, destType, jReciever) {
      var me = this;
      if (links.length === 0) {
        var toast = new WA.CMP.NTF.Toast();
        toast.show(L('NOT_LINKS_TO_BIND'));
      }

      WA.SRV.session.pasteLinks(links, destID, destType).done(function (count) {
        for (var i = 0; i < links.length; i++) {
          links[i].showBindIcon();
        };
        jReciever.find('.object-list-item__addicon_type_bound').show();
        var toast = new WA.CMP.NTF.Toast();
        if (count > 0) {
          toast.show(L('BOUND_LINKS', count));
        } else {
          toast.show(L('NOT_LINKS_TO_BIND'));
        }
        me.removeSelection();
        UpdateSelectionNumbers();
      });

      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Добавление во вложения
    * @function Core.dropping.attachToTask
    * @param {WA.Link[]} links список ссылок
    * @param {Integer} destID if элемента получателя
    * @param {OBJECT_TYPE} destType элемента получателя
    * @param {OBJECT_TYPE} jReciever jquery объект получателя
    * @since 5.1.0.1523
    * @return {Core.dropping}
    */
    attachToTask: function (links, destID, destType, jReciever) {
      var me = this;
      if (links.length === 0) {
        var toast = new WA.CMP.NTF.Toast();
        toast.show(L('NOT_LINKS_TO_ATTACH'));
      }

      WA.SRV.session.pasteLinks(links, destID, destType).done(function (count) {
        var toast = new WA.CMP.NTF.Toast();
        if (count > 0) {
          toast.show(L('ATTACHED_LINKS', count));
        } else {
          toast.show(L('NOT_LINKS_TO_ATTACH'));
        }
        me.removeSelection();
        UpdateSelectionNumbers();
      });
      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Определение типа объекта
    * @function Core.dropping.attachToTask
    * @param {Object} jObject jquery объект объекта
    * @since 5.1.0.1523
    * @return {OBJECT_TYPE}
    */
    getObjectType: function (jObject) {
      if (jObject.hasClass("EDoc_obj")) return OBJECT_TYPE.EDOCUMENT;
      if (jObject.hasClass("Ref_obj")) return OBJECT_TYPE.REFERENCE_RECORD;
      if (jObject.hasClass("Task_obj")) return OBJECT_TYPE.TASK;
      if (jObject.hasClass("Job_obj")) return OBJECT_TYPE.JOB;
      if (jObject.hasClass("Fol_obj")) return OBJECT_TYPE.FOLDER;;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Определение типа папки
    * @function Core.dropping.attachToTask
    * @param {Object} jObject jquery объект папки
    * @since 5.1.0.1523
    * @return {FOLDER_CONTENT_TYPE}
    */
    getFolderType: function (jObject) {
      if (jObject.hasClass('EDocument_fol')) return FOLDER_CONTENT_TYPE.EDOCUMENT;
      if (jObject.hasClass('Job_fol')) return FOLDER_CONTENT_TYPE.JOB;
      if (jObject.hasClass('Task_fol')) return FOLDER_CONTENT_TYPE.TASK;
      if (jObject.hasClass('Any_fol')) return FOLDER_CONTENT_TYPE.ANY;
    }
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  }

})(window.Core);

